module.exports = __webpack_public_path__ + "static/assets/b1cc8ff04a512fd8e9b53b1559bbfdf7.png";